<template>
  <div id="overlay">
    <div id="content">
      <div class="row row-margin">
        <div class="col-12">
          <button class="btn btn-sm btn-outline-primary" v-on:click="add">
            追加する
          </button>
          <button
            class="btn btn-sm btn-outline-info modal-close"
            v-on:click="closeModal"
          >
            キャンセルする
          </button>
        </div>
      </div>
      <div class="row row-margin">
        <div class="col-12 form-inline">
          <div id="select-form" class="border rounded">
            <p v-if="isAddHospitals" id="select-caution">
              アナウンス先を検索して、追加して下さい
            </p>
            <div
              class="form-inline border rounded select-item"
              v-for="addHospital in addHospitals"
              v-bind:key="addHospital.id"
            >
              {{ addHospital.hospitalName }}
              <button
                class="btn btn-sm .border.border-0"
                v-on:click="removeHospital(addHospital.id)"
              >
                <img class="times-solid-sm" src="/times-solid.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <form class="input-group" @submit.prevent="searchHospital(searchKey)">
        <input
          type="text"
          class="form-control"
          placeholder="Code、名称"
          v-model="searchKey"
        />
        <div class="input-group-append">
          <button class="btn btn-secondary" type="submit">
            <img class="search-solid" src="/search-solid.svg" />
          </button>
        </div>
      </form>
      <div class="table-scroll">
        <table class="table table-sm table-hover form-table">
          <thead>
            <tr>
              <th scope="col" style="width: 40px; border: none"></th>
              <th scope="col" style="width: 60px; border: none"></th>
              <th scope="col" style="width: 120px; border: none"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="searchHospital in searchHospitals"
              v-bind:key="searchHospital.id"
            >
              <td>
                <button
                  type="button"
                  class="btn-sm"
                  v-on:click="addHospital(searchHospital.id)"
                >
                  <img class="plus-solid" src="/plus-solid.svg" />
                </button>
              </td>
              <td>{{ searchHospital.hospitalCode }}</td>
              <td>{{ searchHospital.hospitalName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="pager">
        <ul class="pagination justify-content-center">
          <li v-if="isPrev" v-on:click="goPrev">
            <a class="btn page-link rounded-pill">&larr; 前</a>
          </li>
          <li v-if="isPrev || isNext" class="mx-2">
            <a class="btn page-link rounded-pill">現在</a>
          </li>
          <li v-if="isNext" v-on:click="goNext">
            <a class="btn page-link rounded-pill">次 &rarr;</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { sessions } from "../mixin/session";
import { headers } from "../mixin/headers";

/* eslint-disable */
// 下位コンポーネントから上位コンポーネントを変更しようとしている。 20230901
export default {
  name: "HospitalModal",
  mixins: [sessions, headers],
  data: function () {
    return {
      searchKey: "",
      searchHospitals: [],
      addHospitals: [],
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
    };
  },
  props: ["targets", "parentName", "exclusionId", "realms"],
  mounted() {
    this.initModal();
  },
  methods: {
    initModal() {
      this.searchHospitals = [];
      this.addHospitals = [];
    },
    closeModal() {
      this.$emit("close-modal");
      this.initModal();
    },
    getHospitals(session, searchKey) {
      var accessToken = this.getAccessToken(this.$cognito, session);
      var exclusionId = Number(this.exclusionId);
      var offset = this.currentIndex * this.limit;

      if (exclusionId === -1) {
        return axios.post(
          "/api/hospital/list/announce/" + offset,
          {
            searchKey: searchKey,
          },
          {
            headers: this.headers(accessToken),
          }
        );
      } else {
        return axios.post(
          "/api/hospital/list/without/announce/" + offset,
          {
            announceId: exclusionId,
            searchKey: searchKey,
          },
          {
            headers: this.headers(accessToken),
          }
        );
      }
    },
    searchHospital(searchKey) {
      this.$cognito
        .isAuthenticated()
        .then((session) => {
          if (session) {
            this.getHospitals(session, searchKey)
              .then((response) => {
                var res = response.data;
                if (res.errorMessage) {
                  this.message = res.errorMessage;
                } else {
                  var selects = [];
                  this.targets.forEach((element) => {
                    selects.push(element.hospitalId);
                  });
                  this.addHospitals.forEach((element) => {
                    selects.push(element.id);
                  });
                  var hospitals = res.data.hospitals.filter((element) => {
                    return selects.every(
                      (currentValue) => currentValue != element.id
                    );
                  });
                  this.searchHospitals = hospitals;
                  this.gridCount = res.data.hospitals.length;
                }
              })
              .catch((err) => {
                throw err;
              });
          }
        })
        .catch((err) => {
          this.message = err.message;
        });
    },
    goNext() {
      this.currentIndex++;
      this.searchHospital(this.searchKey);
    },
    goPrev() {
      this.currentIndex--;
      this.searchHospital(this.searchKey);
    },
    addHospital(id) {
      var hospital = this.searchHospitals.find((element) => element.id === id);
      this.addHospitals.push(hospital);
      var index = this.searchHospitals.findIndex(
        (element) => element.id === id
      );
      this.searchHospitals.splice(index, 1);
    },
    removeHospital(id) {
      var hospital = this.addHospitals.find((element) => element.id === id);
      this.searchHospitals.push(hospital);
      var index = this.addHospitals.findIndex((element) => element.id === id);
      this.addHospitals.splice(index, 1);
      var sortlist = this.searchHospitals.sort(function (a, b) {
        return a.hospitalCode > b.hospitalCode === true ? 1 : -1;
      });
      this.searchHospitals = sortlist;
    },
    add() {
      if (this.parentName === "announce") {
        this.addHospitals.forEach((element) => {
          this.targets.push({
            hospitalId: element.id,
            hospital: {
              hospitalCode: element.hospitalCode,
              hospitalName: element.hospitalName,
            },
          });
        });
        var announcelist = this.targets.sort(function (a, b) {
          return a.hospital.hospitalCode > b.hospital.hospitalCode === true
            ? 1
            : -1;
        });
        this.$emit("add-target", announcelist);
      } else {
        this.addHospitals.forEach((element) => {
          this.targets.push({
            hospitalId: element.id,
            hospital: {
              hospitalCode: element.hospitalCode,
              hospitalName: element.hospitalName,
            },
          });
        });
        var sortlist = this.targets.sort(function (a, b) {
          return a.Hospital.hospitalCode > b.Hospital.hospitalCode === true
            ? 1
            : -1;
        });
        this.$emit("add-target", sortlist);
      }
      this.initModal();
    },
  },
  computed: {
    isAddHospitals: function () {
      return this.addHospitals.length === 0;
    },
    isNext: function () {
      return this.gridCount === this.limit;
    },
    isPrev: function () {
      return this.currentIndex !== 0;
    },
  },
};
</script>

<style scoped>
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content {
  z-index: 2;
  width: 50%;
  padding: 1em;
  background: #fff;
}
.modal-close {
  float: right;
}
.row-margin {
  margin-bottom: 10px;
}
.search-solid {
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.table-scroll {
  position: relative;
  height: 200px;
  overflow: auto;
}
#select-form {
  width: 100%;
  min-height: 35px;
}
#select-caution {
  margin-top: 5px;
  margin-left: 5px;
  margin-bottom: 0;
}
.select-item {
  display: inline;
}
.plus-solid {
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.times-solid-sm {
  cursor: pointer;
  height: 12px;
  width: 12px;
}
</style>
